import React from "react";
import { Icon } from "@storaensods/seeds-react";

export default ({ difficulty }) => {
  const filledStars = Array(difficulty)
    .fill()
    .map((e, i) => <Icon key={`fs${i}`} color="blue">star</Icon>)

  const emptyStars = Array(5 - difficulty)
    .fill()
    .map((e, i) => <Icon key={`es${i}`}>star</Icon>)

  return (
    <div
      className="se-pt-2xs se-mb-lg"
      style={{
        display: "flex",
        alignItems: "center",
        color: "#D6D9DF"
      }}
    >
      {filledStars}{emptyStars}
    </div>
  )
}
